import { modalTooltips } from 'src/components/Tooltip/DefinitionTooltip/content/modalTooltips';
import { pageTooltips } from 'src/components/Tooltip/DefinitionTooltip/content/pageTooltips';
import { tableTooltips } from 'src/components/Tooltip/DefinitionTooltip/content/tableTooltips';
import { commonTooltips } from 'src/components/Tooltip/DefinitionTooltip/content/commonTooltips';
import { DefinitionTooltipConfig } from 'src/components/Tooltip/DefinitionTooltip/types';

export const DEFINITION_TOOLTIP_CONFIG_BY_ID = {
	...pageTooltips,
	...modalTooltips,
	...tableTooltips,
	...commonTooltips,
} as const satisfies Record<string, DefinitionTooltipConfig>;

export type DefinitionTooltipID = keyof typeof DEFINITION_TOOLTIP_CONFIG_BY_ID;
